import Comment from './Comment'
export * from './types'
export default Comment
